module.exports = __webpack_public_path__ + "static/media/Brasão Alagoas 100px.061829b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Brasão Alagoas 100px.png
// module id = 244
// module chunks = 0